import script from "./mainSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./mainSwiper.vue?vue&type=script&setup=true&lang=js"

import "./mainSwiper.vue?vue&type=style&index=0&id=2f252e71&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f252e71"]])

export default __exports__